import { APP_URL } from 'shared/constants/common';
import { CategoryDataInterface } from 'shared/interface';
import { isEsport, removeMultipleDash, removeSpecialCharacter } from './utility';

export const generateUrl = (item: CategoryDataInterface) => {
	const sportOrEsport = isEsport(item) ? APP_URL.eSport : APP_URL.sport;

	const { level, sportId, sportName, categoryName, categoryId, parentName } = item;

	let pathname;

	const state = {
		sportId: sportId,
		sportName: sportName,
	};

	if (level === 1) {
		pathname = `${sportOrEsport}/${removeSpecialCharacter(categoryName)}`;
	} else if (level === 2) {
		pathname = removeMultipleDash(`${sportOrEsport}/${removeSpecialCharacter(sportName)}/${removeSpecialCharacter(categoryName)}/${categoryId}`);
	} else {
		pathname = removeMultipleDash(
			`${sportOrEsport}/${removeSpecialCharacter(sportName)}/${removeSpecialCharacter(parentName)}/${removeSpecialCharacter(
				categoryName,
			)}/${categoryId}`,
		);
	}

	return { pathname, state };
};
